<template>
  <div class="col-12">
    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 2 -->
      <register-form
        :formStepId="1"
        :stepForm="1"
        :step="steps[1]"
        :realStep="1"

        :editFunction="editFunction"
        :editStatus="editStatus"
        :isApproved="isApproved"
        isBackend
      >
        <div class="row mt-2">
          <div class="col-3">
            <template v-if="haveDisplay">
              <img :src="`${basePublicUrl}${form.display}`"
                   class="rounded mx-auto m-auto d-block" style="max-height: 90px; max-width: 90px">
              <div class="text-center">
                <a v-show="editStatus === `editing`" @click="removeImage(`display`)" class="small">remove</a>
              </div>
            </template>
            <template v-else-if="!haveDisplay">
              <file-pond
                :disabled="editStatus !== `editing`"
                name="formDisplay"
                ref="formDisplay"
                class-name="my-pond"
                label-idle="Click or Drop files here..."
                maxFileSize="5MB"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png"
                v-model="form.display"
              />
            </template>
          </div>
          <div class="col-8">
            <h5 class="required">Display</h5>
            <p class="mb-2">.JPEG, .PNG ขนาดไฟล์ไม่เกิน 5MB</p>
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12">
            <label class="h5 required" for="textarea1"
            >ข้อมูลเกี่ยวกับบริษัท</label
            >
          </div>
        </div>
        <div class="form-group row mx-2">
            <textarea
              :disabled="editStatus !== `editing`"
              v-model="form.description"
              class="form-control"
              id="textarea1"
              rows="10"
              placeholder="ระบุข้อมูลเกี่ยวกับบริษัท"
            ></textarea>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12">
            <label class="h5 required" for="textarea2">ตำแหน่งที่รับ</label>
          </div>
        </div>
        <div class="form-group row mx-2 mb-3">
            <textarea
              :disabled="editStatus !== `editing`"
              v-model="form.available_job"
              class="form-control"
              id="textarea2"
              rows="10"
              placeholder="ระบุตำแหน่งที่รับ"
            ></textarea>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12">
            <label class="h5 required" for="textarea2">สาขาที่รับ</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 font-weight-normal row">
            <div
              class="form-group row custom-control custom-checkbox custom-control-solid ml-2 ml-sm-4 mb-2 d-flex justify-content-start"
            >
              <div
                class="col-6 col-sm-5"
                v-for="(faculty, facultyId) in faculties"
                :key="`facultyId${facultyId}`"
              >
                <input
                  :disabled="editStatus !== `editing`"
                  class="custom-control-input"
                  :id="`facultyCheckedbox${facultyId}`"
                  type="checkbox"
                  :value="faculty"
                  v-model="form.interest_faculties"
                />
                <label
                  class="custom-control-label"
                  :for="`facultyCheckedbox${facultyId}`"
                >{{ faculty }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 ">
            <h5 class="required">โปสเตอร์/โบรชัวร์</h5>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-3">


            <template v-if="haveBrochure">
              <template v-if="form.brochure.includes(`.pdf`)">
                <div class="text-center">
                  {{currentPage}} / {{rows}}
                  <pdf class="mt-1" :src="`${basePublicUrl}${form.brochure}`"
                       @numpages="rows = $event" :page="currentPage">
                    <template slot="loading">
                      loading content here...
                    </template>
                  </pdf>

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="1"
                    class="danger mt-1"
                    page-class="d-none"
                    hide-ellipsis
                    align="center"
                    size="md"
                    hide-goto-end-buttons
                  >
                    <template v-slot:prev-text><i class="fas fa-angle-left"></i></template>
                    <template v-slot:next-text><i class="fas fa-angle-right"></i></template>
                    <template v-slot:page="{ page, active }">
                      <b v-if="active">{{ page }}</b>
                      <b v-else>{{ page }}</b>
                    </template>
                  </b-pagination>
                </div>
              </template>
              <template v-else>
                <img :src="`${basePublicUrl}${form.brochure}`"
                     class="rounded mx-auto m-auto d-block" style="max-height: 90px; max-width: 90px;">
              </template>

              <div class="text-center">
                <a v-show="editStatus === `editing`" @click="removeImage(`brochure`)" class="small">remove</a>
              </div>
            </template>
            <template v-else-if="!haveBrochure">
              <file-pond
                :disabled="editStatus !== `editing`"
                name="formBrochure"
                ref="formBrochure"
                class-name="my-pond"
                label-idle="Click or Drop files here..."
                maxFileSize="5MB"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png, application/pdf, application/x-pdf, application/x-bzpdf, application/x-gzpdf"
                v-model="form.brochure"
              />
            </template>


          </div>
          <div class="col-8">
            <label class="font-weight-normal"
            >สามารถแนบโปสเตอร์หรือโบรชัวร์ เพื่อแสดงผลใต้ข้อมูล <br>หากมีมากกว่า 1 ภาพ/ไฟล์ กรุณารวมเป็น PDF 1
              ไฟล์</label
            >
            <p class="mb-2">.JPEG, .PNG, .PDF ขนาดไฟล์ไม่เกิน 5MB</p>
          </div>
        </div>


        <div class="row mt-5 mb-2">
          <div class="col-12">
            <label class="h5 required" for="emailForContactBack"
            >E-mail สำหรับนักศึกษาติดต่อกลับ</label
            >
          </div>
        </div>
        <div class="form-group row mx-2">
          <input
            :disabled="editStatus !== `editing`"
            type="text"
            class="form-control form-control-user"
            id="emailForContactBack"
            v-model="form.email"
            placeholder="E-mail สำหรับนักศึกษาติดต่อกลับ"
            style="padding: 1.2rem 1rem;"
          />
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12">
            <label class="h5 required" for="WebsiteForContact"
            >เว็บไซต์/เพจ ข้อมูลเพิ่มเติม</label
            >
          </div>
        </div>
        <div class="form-group row mx-2">
          <input
            :disabled="editStatus !== `editing`"
            type="text"
            class="form-control form-control-user"
            id="WebsiteForContact"
            v-model="form.website"
            placeholder="เว็บไซต์/เพจ ข้อมูลเพิ่มเติม (link)"
            style="padding: 1.2rem 1rem;"
          />
        </div>
      </register-form>
    </fade-transition>
    <b-modal hide-header v-model="openModal" size="lg">

      <div class="d-flex justify-content-center mt-5">
        {{contentModal}}
      </div>
      <template v-if="nonFields !== []">
        <ul>
          <li :key="`nonfields-${index}`" v-for="(field, index) in nonFields">
            {{field}}
          </li>
        </ul>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="openModal = false"
                      class="btn-engineer btn-user btn-block mt-0">
              <h6 class="mb-0 w-auto">ปิด</h6>
            </b-button>
          </div>
        </div>

      </template>
    </b-modal>
  </div>
</template>

<script>
  import registerForm from "@/components/forms/registerForm";
  import moment from "moment";
  // eslint-disable-next-line no-unused-vars
  import api from "@/services/api";
  import pdfvuer from 'pdfvuer'


  moment.locale("th");

  // eslint-disable-next-line no-unused-vars
  import firebase from "firebase/app";
  import "firebase/auth";

  // Import Vue FilePond
  import vueFilePond from "vue-filepond";

  // Import FilePond styles
  import "filepond/dist/filepond.min.css";

  // Import FilePond plugins
  // Please note that you need to install these plugins separately

  // Import image preview plugin styles
  import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

  // Import imagane preview d file type validation plugins
  import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
  import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
  import FilePondPluginImagePreview from "filepond-plugin-image-preview";

  import {mapActions} from "vuex";

  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImagePreview
  );

  const publicUrl = 'https://engjob.kmutt.ac.th/api/public/'

  export default {
    title: "Job Fair Faculty of Engineering - Company Description",
    name: "descriptionForm",
    components: {
      registerForm,
      FilePond,
      "pdf": pdfvuer
    },
    data() {
      return {
        basePublicUrl: publicUrl,
        pageCount: 0,
        currentPage: 1,
        rows: 1,
        form: {
          available_job: "",
          brochure: "",
          description: "",
          display: "",
          interest_faculties: [],
        },
        haveDisplay: true,
        haveBrochure: true,
        faculties: [
          "วศ.บ. วิศวกรรมการผลิตชิ้นส่วนยานยนต์",
          "วท.บ. วิทยาศาสตร์ข้อมูลสุขภาพ",
          "วศ.บ. วิศวกรรมคอมพิวเตอร์",
          "วศ.บ. วิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเคมี ",
          "วศ.บ. วิศวกรรมเคมี (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเครื่องกล",
          "วศ.บ. วิศวกรรมเครื่องกลและพลังงาน",
          "วศ.บ. วิศวกรรมเครื่องมือ",
          "วศ.บ. วิศวกรรมไฟฟ้า",
          "วศ.บ. วิศวกรรมไฟฟ้า (ระบบไฟฟ้า อิเล็กทรอนิกส์ และพลังงาน)",
          "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์",
          "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเมคคาทรอนิกส์",
          "วศ.บ. วิศวกรรมยานยนต์",
          "วศ.บ. วิศวกรรมโยธา",
          "วศ.บ. วิศวกรรมโยธา (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมระบบควบคุมและเครื่องมือวัด",
          "วศ.บ. วิศวกรรมวัสดุ",
          "วศ.บ. วิศวกรรมสิ่งแวดล้อม",
          "วศ.บ. วิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ) ",
          "วศ.บ. วิศวกรรมอุตสาหการ"
        ],
        steps: [
          {
            title: "ข้อมูลเบื้องต้น",
            subtitle: ""
          },
          {
            title: "ข้อมูลเกี่ยวกับ",
            subtitle: "บริษัท/ตำแหน่งที่รับ"
          },
          {
            title: "ข้อมูล Job Fair",
            subtitle: ""
          },
          {
            title: "บันทึกข้อมูล",
            subtitle: ""
          }
        ],
        formData: {},
        isEmailFormat: true,
        isPhoneFormat: true,
        isPasswordFormat: true,
        editStatus: "edit",
        isApproved: true,
        getCompanyDetail: {},
        nonFields: [],
        openModal: false,
        contentModal: ""
      };
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      ...mapActions(["getCompanyData", "updateCompanyDataState"]),
      onSubmit: async function () {
        let formData = new FormData();
        // eslint-disable-next-line no-unused-vars
        let register_form = {
          address: {
            building_road: this.form.address.building_road,
            city: this.form.address.city,
            province: this.form.address.province,
            zip_code: this.form.address.zip_code
          },
          available_job: this.form.available_job,
          contact_person: {
            email: this.form.contact_person.email,
            firstName: this.form.contact_person.firstName,
            lastName: this.form.contact_person.lastName,
            phone: this.form.contact_person.phone,
            position: this.form.contact_person.position
          },
          description: this.form.description,
          email: this.form.email,
          id: "",
          industry_group: this.form.industry_group,
          interest_faculties: this.form.interest_faculties,
          name: this.form.name,
          meeting_times: this.form.meeting_times,
          online_meeting: this.form.online_meeting,
          status: "",
          website: this.form.website
        }

        if (this.haveDisplay === false) {
          if (this.$refs.formDisplay.getFiles()[0].file) {
            // eslint-disable-next-line no-unused-vars
            let display = new File(
              [this.$refs.formDisplay.getFiles()[0].file],
              this.$refs.formDisplay.getFiles()[0].file.name
            );
            formData.append("display", display);
          }
        }

        if (this.haveBrochure === false) {
          if (this.$refs.formBrochure.getFiles()[0].file) {
            // eslint-disable-next-line no-unused-vars
            let brochure = new File(
              [this.$refs.formBrochure.getFiles()[0].file],
              this.$refs.formBrochure.getFiles()[0].file.name
            );
            formData.append("brochure", brochure);

          }
        }

        formData.append("register_form", JSON.stringify(register_form));

        firebase
          .auth()
          .currentUser.getIdToken(false)
          .then(idToken => {
            api.updateCompanyDetail(idToken, formData).then(() => {
              this.updateCompanyDataState(register_form).finally(() => {
                location.reload();
              });
            })
              .catch(err => {
                console.log(err)
                location.reload();
              });
          })
      },
      saveData() {
        let available = this.checkStepFirst();
        if (available === true) {
          this.alertModal("บันทึกการแก้ไขแล้ว");
          this.onSubmit().finally(() => {
            this.editStatus = "edit";
          });
        } else {
          this.alertModal("กรุณากรอกข้อมูลให้ครบทุกช่อง", this.nonFields);
        }
      },
      removeImage(type) {
        if (type === `display`) {
          this.haveDisplay = false;
        } else if (type === `brochure`) {
          this.haveBrochure = false;
        }
      },
      alertModal(massage) {
        this.openModal = true;
        this.contentModal = massage
      },
      checkStepFirst() {
        let checkFirstStep = 0;
        let allFields = ["ข้อมูลเกี่ยวกับบริษัท", "ตำแหน่งที่รับ", "สาขาที่รับ", "E-mail สำหรับนักศึกษาติดต่อกลับ", "เว็บไซต์/เพจ ข้อมูลเพิ่มเติม"];
        let passedFields = [];
        this.nonFields = [];

        if (this.haveDisplay) {
          checkFirstStep++;
        } else {
          if (this.$refs.formDisplay.getFiles().length > 0) {
            checkFirstStep++;
          }
        }

        if (this.haveBrochure) {
          checkFirstStep++;
        } else {
          if (this.$refs.formBrochure.getFiles().length > 0) {
            checkFirstStep++;
          }
        }

        if (this.form.interest_faculties.length > 0) {
          passedFields.push("สาขาที่รับ");
          checkFirstStep++;
        }

        if (this.form.description) {
          passedFields.push("ข้อมูลเกี่ยวกับบริษัท");
          checkFirstStep++;
        }
        if (this.form.available_job) {
          passedFields.push("ตำแหน่งที่รับ");
          checkFirstStep++;
        }

        if (this.form.email && this.checkEmail(this.form.email)) {
          passedFields.push("E-mail สำหรับนักศึกษาติดต่อกลับ");
          checkFirstStep++;
        }
        if (this.form.website) {
          passedFields.push("เว็บไซต์/เพจ ข้อมูลเพิ่มเติม");
          checkFirstStep++;
        }

        allFields.forEach(field => {
          if (!passedFields.includes(field)) {
            this.nonFields.push(field)
          }
        });

        if (checkFirstStep === 7) {
          return true
        } else {
          return false
        }
      },
      checkEmail(email) {
        let re = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        this.isEmailFormat = re.test(email);
        return this.isEmailFormat;
      },
      editFunction() {
        if (this.editStatus === "edit") {
          this.editStatus = "editing";
        } else if (this.editStatus === "editing") {
          this.saveData()
        }
      },

      fetchData() {
        if (firebase.auth().currentUser) {
          let uid = firebase.auth().currentUser.uid;
          firebase
            .auth()
            .currentUser.getIdToken(false)
            .then(idToken => {
              api
                .getCompanyDetial(idToken, {
                  id: uid
                })
                .then(res => {
                  let companyData = {
                    data: res.data.data[0],
                    isSuccess: res.data.isSuccess,
                    token: idToken
                  };
                  this.$store.state.companyData = companyData.data;
                  this.$store.state.companyContact = companyData.data.contact_person.firstName;
                  this.$store.state.token = idToken;
                  this.getCompanyDetail = companyData;
                  this.form = companyData.data;

                  if (this.form.display !== "" && this.form.display !== []) {
                    this.haveDisplay = true;
                  } else {
                    this.haveDisplay = false;
                  }

                  if (this.form.brochure !== "" && this.form.brochure !== []) {
                    this.haveBrochure = true;
                  } else {
                    this.haveBrochure = false;
                  }

                })
                .catch(err => {
                  console.log(err);
                });
            });
        }
      },
    },
  };
</script>

<style scoped>
  .btn-user {
    font-size: 0.8rem;
    border-radius: 10rem;
    padding: 0.75rem 1rem;
  }

  a:not([href]):not([tabindex]), a:not([href]):not([tabindex]) {
    color: #4e73df;
    text-decoration: none;
    background-color: transparent;
  }

  a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
    color: #224abe;
    text-decoration: underline;
    cursor: pointer;
  }
</style>